export const MAIN_SITE_HOST = process.env.REACT_APP_SITE_HOST || "hostvds.com";
